import React from "react"
import { ButtonParts } from "~/components/atoms/ButtonParts"
import { Customer } from "~/models/Customer"

interface Props {
  onAction?: (params: {}) => void,
  isValid: boolean,
  customer: Customer,
  isNext?: boolean
}

export function VerifyFooter(props: Props) {
  const { onAction, isValid = false, isNext } = props
  return (
    <>
      {/*<div className="verify-footer">*/}
      {/*  <div className={"dropdown sample-change"}>*/}
      {/*    <ButtonParts className={"btn btn-dropdown dropdown-toggle"} action={onAction} disabled={!isValid}>*/}
      {/*      {isNext ? "次へ" : "料金シミュレートを開始"}*/}
      {/*      <span className="ar-right"></span>*/}
      {/*    </ButtonParts>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {isNext !== null &&
        <div className="pack-info-btn-area">
          <ButtonParts className={"btn btn-primary btn-dropdown dropdown-toggle"} action={onAction} disabled={!isValid}>
            {isNext ? "次へ" : "料金シミュレートを開始"}
            <span className="ar-right"></span>
          </ButtonParts>
        </div>
      }
    </>
  )
}

